import axios from 'axios'

/**
 * Base API endpoint configuration
 * Prioritizes runtime config over environment variables
 */
const API_ENDPOINT =
  window?.RUNTIME_CONFIG?.REACT_APP_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT

/**
 * Axios client instance with base configuration
 * Interceptors will be configured in SetupAxios.tsx for token refresh and error handling.
 * The X-CSRFToken header is set per-request in the request interceptor so it always
 * reflects the current `csrftoken` cookie (it must not be cached at module load).
 */
export const apiClient = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

// NOTE: Interceptors are added to this instance by setupAxios() in index.tsx
